(function () {
  var MARKET_LOCATIONS = ['MY', 'TH', 'PH', 'VN', 'ID'];
  var country = window.__marketAvailabilityCountry;
  if (!country || MARKET_LOCATIONS.indexOf(country) === -1) return;

  var dataUrl = window.__marketAvailabilityDataUrl;
  if (!dataUrl) return;

  function getVariantInput() {
    return document.querySelector('form[action*="/cart/add"] input[name="id"]');
  }

  function getAddToCartButtons() {
    return document.querySelectorAll(
      'form[action*="/cart/add"] button[type="submit"], accelerated-checkout-buttons, [data-shopify="payment-button"]'
    );
  }

  function ensureNotice() {
    var existing = document.getElementById('market-unavailable-notice');
    if (existing) return existing;
    var input = getVariantInput();
    if (!input || !input.form) return null;
    var notice = document.createElement('p');
    notice.id = 'market-unavailable-notice';
    notice.style.cssText = 'font-size:13px;color:#b3261e;margin:8px 0 0;';
    notice.hidden = true;
    notice.textContent = 'Currently unavailable for delivery in your region.';
    input.form.parentElement.appendChild(notice);
    return notice;
  }

  function applyRestriction(unavailableHere) {
    var notice = ensureNotice();
    var buttons = getAddToCartButtons();
    buttons.forEach(function (el) {
      if (unavailableHere) {
        if (el.tagName === 'BUTTON') {
          el.dataset.marketDisabled = 'true';
          el.disabled = true;
        } else {
          el.style.display = 'none';
        }
      } else if (el.dataset && el.dataset.marketDisabled === 'true') {
        el.disabled = false;
        delete el.dataset.marketDisabled;
      } else if (el.dataset && el.dataset.marketDisabled !== undefined) {
        el.style.display = '';
      }
    });
    if (notice) notice.hidden = !unavailableHere;
  }

  fetch(dataUrl)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var map = data[country] || {};
      var input = getVariantInput();
      if (!input) return;
      var lastValue = null;

      function check() {
        var variantId = input.value;
        if (variantId === lastValue) return;
        lastValue = variantId;
        // map[variantId] === false means: out of stock at this market's dedicated
        // location, even though the variant may show as globally available.
        // Never override an existing Shopify-side disable (never loosens availability).
        if (map[variantId] === false) {
          applyRestriction(true);
        } else {
          applyRestriction(false);
        }
      }

      check();
      new MutationObserver(check).observe(input, { attributes: true, attributeFilter: ['value'] });
      setInterval(check, 400);
    })
    .catch(function () {
      // Fail silently: on any error, leave Shopify's default availability untouched.
    });
})();
